import React, { useState, useEffect } from 'react'

const FMRadio = props => {
  const [currentChannel, setCurrentChannel] = useState(-1);
  const channelAudio = `FM_channel_${currentChannel}`;

  useEffect(() => { // showing fail-screen does not unmount this component so let's manually remove audio
    props.audioController.removeAudio(channelAudio);
  }, [props.crossingOver])

  useEffect(() => {
    if (!isNaN(props.data.initialChannel)) { // initialize audio for relevant crossings
      togglePower()
      // setCurrentChannel(props.data.initialChannel)
    }
  }, [props.data.initialChannel])

  useEffect(() => {
    if (currentChannel > -1) {
      props.audioController.playAudioByName(channelAudio);
    }
    return () => {
      if (currentChannel > -1) {
    // remove audio before unmount
        props.audioController.removeAudio(channelAudio);
      }
    }
  }, [currentChannel])

  const togglePower = () => {    
    props.onPower()
    if (currentChannel === -1) {
        setCurrentChannel(props.data.initialChannel || 0);
    } else {
      props.audioController.removeAudio(channelAudio);
      setCurrentChannel(-1);
    }
  };

  const switchChannels = () => {
    if (currentChannel > -1) {
      props.audioController.removeAudio(channelAudio)
      setCurrentChannel(currentChannel !== 2 ? currentChannel+1 : 0); // 3 channels total (hence the 2)
    }
  }
  return (
    <div className={`FMRadio ${props.view}`} >
      <div className={`power-button`} onClick={togglePower} />
      <div className={`channels ${currentChannel > -1 ? 'on' : 'off'}`} onClick={switchChannels} />
    </div>
  )
};

export default FMRadio